module.exports = __webpack_public_path__ + "r-v3/img/img_progress.232d74c2.svg";